function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.745,
    height: 296.241,
    viewBox: "0 0 62.639 78.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M455.731 228.498c-6.561-7.104-13.3-13.628-17.076-19.106-9.199-13.34-10.93-25.962-20.489-39.12 19.223-11.932 49.19-41.351 22.44-54.188-13.144-6.307-37.082 14.982-47.55 25.299-4.458-5.052-8.273-8.917-9.171-8.468l-43.232 21.616c-6.695 3.408-13.072 15.742-13.072 15.742-13.291 6.608-55.898 10-56.966 29.158-.486 8.732 4.995 14.81 12.867 17.768 15.522 5.833 30.077-3.517 44.1-7.704 3.414 13.537 8.236 23.614 7.806 37.669-.56 18.242-15.388 59.836 7.849 65.914 40.486 10.59 39.561-24.768 36.255-52.407 10.265.958 20.875-.657 29.84-5.647a70 70 0 0 0 4.67-2.848C427.075 276.398 455 296 470.669 270.565c8.625-14-2.904-29.038-14.938-42.067",
    style: {
      fill: "#914e20"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.828 173.04c-14.373-4.177-32.223 4.207-39.982 17.798-10.349 18.127 5.56 40.064 23.413 45.98 9.498 3.148 21.075 1.184 28.54-5.695 11.358-10.464 10.337-34.491 2.534-46.902-3.75-5.961-8.858-9.54-14.505-11.181",
    style: {
      fill: "#b56a37"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.673 91.669a24.7 24.7 0 0 0-.732 7.024c.313 8.461 3.922 16.301 10.385 21.819 1.934 1.65 20.059 12.562 21.89 7.904 0-.003 17.253-43.901 17.257-43.912 1.625-4.135-14.128-10.99-16.732-11.51-14.068-2.806-28.644 5.254-32.068 18.675",
    style: {
      fill: "#914e20"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.773 91.912c-5.771 10.568 3.058 23.477 17.141 25.67l10.525-30.212c-8.244-3.429-19.12-11.108-27.666 4.542",
    style: {
      fill: "#b56a37"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.252 20.178a24.7 24.7 0 0 1 6.218 3.348c6.819 5.021 11.268 12.416 12.192 20.863.275 2.527-.904 23.65-5.785 22.542l-46.01-10.448c-4.332-.984-1.134-17.863-.098-20.308 5.597-13.207 20.462-20.72 33.483-15.997",
    style: {
      fill: "#914e20"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.207 29.491c11.857 2.1 17.686 15.739 11.572 28.615l-30.897-8.303c1.807-8.744 2.263-23.333 19.325-20.312",
    style: {
      fill: "#b56a37"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.584 61.404c-29.297-22.25-80.969-19.574-105.892 7.158-19.549 20.968-28.317 51.511-17.941 79.008 17.52 46.42 83.694 24.524 112.77 4.363 8.831-6.124 18.707-14.554 24.781-23.524 15.341-22.658 7.942-50.554-13.718-67.005",
    style: {
      fill: "#914e20"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.715 97.888c-18.958-3.949-46.259 6.954-57.126 23.414-14.646 22.187 10.908 42.15 31.765 39.137 16.106-2.327 33.98-12.678 41.486-27.482 8.811-17.373 2.462-31.116-15.983-35.039z",
    style: {
      fill: "#b56a37"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.196 103.169c-5.198-3.653-17.759-.939-22.911 3.284-24.372 19.976 14.768 27.403 24.048 6.103 2.067-4.75 1.227-7.726-1.137-9.387",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.086 104.257c-2.699.129-5.968 3.121-4.146 6.194 2.375 4.004 6.659 2.557 7.124-1.925.332-3.195-1.2-4.353-2.978-4.269",
    style: {
      fill: "#fff"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.509 114.177a8.405 8.405 0 1 1-16.721-1.723 8.405 8.405 0 0 1 16.721 1.723",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.365 112.45a2.166 2.166 0 1 1-4.31-.444 2.166 2.166 0 0 1 4.31.444",
    style: {
      fill: "#fff"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46 87.971a8.406 8.406 0 1 1-16.723-1.723 8.406 8.406 0 0 1 16.723 1.723",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.316 86.244a2.166 2.166 0 1 1-4.309-.443 2.166 2.166 0 0 1 4.309.443",
    style: {
      fill: "#fff"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.561 122.17c.172-2.964-4.415-3.858-4.59-.858-.563 9.662-11.237 16.779-20.136 11.999-2.66-1.429-4.689 2.779-2.046 4.198 11.336 6.089 26.034-2.668 26.772-15.339",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-62.686 -4.963)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOso);
export default __webpack_public_path__ + "static/media/oso.4e291a5e21f29323b45fd33e64fc1032.svg";
export { ForwardRef as ReactComponent };